import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import usersList from './getUsersList';
import clientUsersList from './getClientUsersList';
import userData from './getUserData';
import userRoles from './getUserRoles';
import roleList from './getRoleList';
import dashboardData from './getDashboardData';
import softwareList from './getSoftwareList';
import getSoftwareSettingsList from './getSoftwareSettingsList';
import clientList from './getClientList';
import clientData from './getClientData';
import softwareData from './getSoftwareData';
import clientSoftwares from './getClientSoftwares';
import clientSoftwareChartData from './getClientSoftwareChartData';
import downloadSoftwareChartData from './getDownloadSoftwareChartData';
import platformList from './getPlatformList';
import platformAlertList from './getPlatformAlertList';
import softwarePlatforms from './getSoftwarePlatforms';
import getSoftwareSubmoduleData from './getSoftwareSubmoduleData';
import softwareSubmoduleAll from './getSoftwareSubmoduleAll';
import clientSoftwareSubmodules from './getClientSoftwareSubmodules';
import getSystemEventList from './getSystemEventList';
import getMLScanList from './getMLScanList';
import getSoftwareListForClient from './getSoftwareListForClient';
import getCrashLogs from './getCrashLogs';
import sharedAuthUrls from './getSharedAuthUrlsData';
import getActiveSessionData from './getActiveSessionData';
import getLicenseTemplates from './getLicenseTemplates';
import getGeneratedLicenses from './getGeneratedLicenses';
import getGeneratedLicense from './getGeneratedLicense';
import getLicenseInstances from './getLicenseInstances';
import getSingleLicenseInstance from './getSingleLicenseInstance';
import getIPFirewallData from './getIPFirewallData';
import smtpSettings from './getSmtpSettings';
import slackSettings from './getSlackSettings';
import userSoftwareSubmodules from './getUserSoftwareSubmodules';
import getSoftwareSubmodule from './getSoftwareSubmodule';
import getLicenseSubInstances from './getLicenseSubInstances';
import getIntelligentModel from './getIntelligentModel';
import cloudClientList from './getCloudClientList';
import cloudClientSoftwareList from './getCloudClientSoftwareList';
import clientDomainList from './getClientDomains';
import softwareSubmoduleVersionsList from './getSoftwareSubmoduleVersionsList';
import softwareVersionsList from './getSoftwareVersionList';
import softwarePlatformsList from './getSoftwarePlatformsList';
import resellersList from './getResellersList';

export default combineReducers({
  form: reduxFormReducer,
  usersList,
  clientUsersList,
  userData,
  userRoles,
  roleList,
  dashboardData,
  softwareList,
  softwareData,
  clientList,
  clientData,
  getCrashLogs,
  clientSoftwares,
  downloadSoftwareChartData,
  clientSoftwareChartData,
  platformList,
  softwarePlatforms,
  getSoftwareSubmoduleData,
  softwareSubmoduleAll,
  clientSoftwareSubmodules,
  getSoftwareListForClient,
  getSystemEventList,
  getMLScanList,
  sharedAuthUrls,
  getActiveSessionData,
  getLicenseTemplates,
  getGeneratedLicenses,
  getIntelligentModel,
  getGeneratedLicense,
  getLicenseInstances,
  getSingleLicenseInstance,
  getIPFirewallData,
  smtpSettings,
  slackSettings,
  userSoftwareSubmodules,
  getSoftwareSettingsList,
  getSoftwareSubmodule,
  getLicenseSubInstances,
  cloudClientList,
  cloudClientSoftwareList,
  clientDomainList,
  softwareVersionsList,
  softwareSubmoduleVersionsList,
  softwarePlatformsList,
  resellersList,
  platformAlertList,
});
